import { RAISE_API_V1_URL } from "constants/endpoints";
import { post } from "services/api";

export const rateBrand = async ({ id, rating }) => {
  const url = `${RAISE_API_V1_URL}/rating/${id}/${rating}`;

  const response = await post(url);
  return response.data;
};
